<section *ngIf="sortedDestinations$ | async as sortedDestinations" class="sort-info-wrapper grid-max-width center">
  <hr class="dn-laptop-up" />
  <div class="grid-max-width padding-left-gutter padding-right-gutter flex">
    <fin-destination-search-origin-selector
      [content]="content"
      [selectedOriginLocationCode]="selectedOriginLocationCode$ | async"
      class="ms-medium-t ms-small-b"
      (originSelected)="onOriginSelected($event)"
    >
    </fin-destination-search-origin-selector>
  </div>
</section>
<section class="grid-max-width grid-col-12">
  <div class="col-1-12">
    <!-- campagin ribbon -->
    <div class="campaign-ribbon" *ngIf="this.ribbon$ | async as ribbon">
      <fin-destination-search-campaign-ribbon
        [bookByText]="ribbon.bookByText"
        [travelPeriodText]="ribbon.travelPeriodText"
        [termsAndConditionText]="ribbon.termsAndConditionText"
        [termsAndConditionLink]="ribbon.termsAndConditionLink$ | async"
        [theme]="ribbon.theme"
      ></fin-destination-search-campaign-ribbon>
    </div>
    <h2 class="is-vishidden">{{ 'destinationSearch.filteredDestinations' | finLocalization }}</h2>
    <fcom-notification
      role="status"
      *ngIf="
        (updatingPricesLoader$ | async) === PriceLoadingState.LOADED && (sortedDestinations$ | async)?.length === 0
      "
      data-testid="destinations-search-no-results"
    >
      <div class="flex flex--column">
        {{ 'destinationSearch.noResultsFound' | finLocalization }}
        <fcom-button
          class="ps-medium-t"
          [text]="'destinationSearch.filters.clearAllFilters' | finLocalization"
          (clickBtn)="clearAllFilters.emit()"
          data-testid="destination-search-no-results-clear-all-button"
        ></fcom-button>
      </div>
    </fcom-notification>

    <div
      data-testid="search-result-wrapper"
      id="search-result-wrapper"
      class="search-result-wrapper fill grid-col-12 no-gutters search-result-wrapper-campaign"
    >
      <div
        role="status"
        class="updating-prices-loader pr-large-t"
        data-testid="destinations-prices-loader"
        *ngIf="(updatingPricesLoader$ | async) === PriceLoadingState.LOADING"
      >
        <span class="align-center pr-small-b block font-body-1">{{
          'destinationSearch.loadingPrices' | finLocalization
        }}</span>
        <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
      </div>

      <ng-template #loadingDestinations>
        <div class="center col-1-12">
          <span class="pr-small-b inline-block font-body-1">{{
            'destinationSearch.loadingDestinations' | finLocalization
          }}</span>
          <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
        </div>
      </ng-template>

      <ng-template #promoItems let-promoItem="promoItem" let-isContinentPromo="isContinentPromo">
        <fcom-promo-card
          [id]="promoItem.segment"
          [class.no-row-space-promo-card]="
            !isContinentPromo && (promoItem?.contentType !== CmsContentType.CMArticle || !promoItem?.target)
          "
          [class.promo-card-image]="promoItem?.contentType === CmsContentType.CMPicture"
          [data$]="promoItem?.contentType === CmsContentType.CMArticle ? (promoItem | finToObservable) : NEVER"
          [imageData$]="
            promoItem?.contentType === CmsContentType.CMArticle && promoItem?.media[0]
              ? (promoItem?.media[0] | finToObservable)
              : promoItem?.contentType === CmsContentType.CMPicture
                ? (promoItem | finToObservable)
                : NEVER
          "
          [ctaData$]="
            promoItem?.contentType === CmsContentType.CMArticle && promoItem?.target
              ? (promoItem?.target | finToObservable)
              : NEVER
          "
          [theme]="
            promoItem?.subjectTaxonomyTags?.includes(CmsTaxonomyGeneral.BLACK_FRIDAY)
              ? PromoTheme.BLACK
              : promoItem?.subjectTaxonomyTags?.includes(CmsTaxonomyGeneral.NORDIC_BLUE_900_BG)
                ? PromoTheme.BLUE
                : PromoTheme.WHITE
          "
          [aspectRatio]="aspectRatioForPromo$ | async"
          [specialGridSizeForLaptop]="true"
          [analyticsEventName]="'destination-search-promo-cta'"
        >
        </fcom-promo-card>
      </ng-template>

      <ng-container *ngFor="let promoItem of topPromoItems$ | async; trackBy: trackByCmsContent">
        <ng-container *ngTemplateOutlet="promoItems; context: { promoItem: promoItem }"></ng-container>
      </ng-container>

      <ng-container *ngIf="categorizedDestinations$ | async as categorizedDestinations; else loadingDestinations">
        <ng-container *ngFor="let category of categoryList$ | async">
          <ng-container *ngIf="categorizedDestinationItems && categorizedDestinations[category]">
            <ng-container
              *ngTemplateOutlet="
                categorizedDestinationItems;
                context: {
                  categoryLabel: categorizedDestinations[category].categoryLabel,
                  destinationItems: categorizedDestinations[category].destinations,
                  promoItem$: categorizedDestinations[category].promo$,
                  selectedOriginLocationCode: selectedOriginLocationCode$ | async,
                }
              "
            ></ng-container>
          </ng-container>
          <ng-template
            #categorizedDestinationItems
            let-categoryLabel="categoryLabel"
            let-destinationItems="destinationItems"
            let-promoItem$="promoItem$"
            let-selectedOriginLocationCode="selectedOriginLocationCode"
          >
            <div class="col-1-12 nordic-blue-900-text font-body-1 mr-small-t" *ngIf="!disableSectionHeadings">
              <p class="font-heading-2">
                {{ categoryLabel | finLocalization }}
              </p>
            </div>
            <ng-container *ngIf="(isFilterApplied$ | async) === false">
              <ng-container *ngIf="promoItem$ | async as promoItem">
                <ng-container
                  *ngTemplateOutlet="promoItems; context: { promoItem: promoItem, isContinentPromo: true }"
                ></ng-container>
              </ng-container>
            </ng-container>

            <fin-destination-search-results-item
              class="landing-page"
              *ngFor="let destination of destinationItems; trackBy: trackByFn"
              (destinationClicked)="destinationClick($event)"
              (flightHotelClicked)="flightHotelClick($event)"
              (calendarClicked)="calendarClicked(selectedOriginLocationCode, $event)"
              [offer]="destination"
              [viewStyle]="viewStyle"
              [enableTeaser]="this.content?.localSettings?.enableTeaser"
              [showRoundTripPrices$]="showRoundTripPrices$"
            ></fin-destination-search-results-item>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container *ngFor="let promoItem of bottomPromoItems$ | async; trackBy: trackByCmsContent">
        <ng-container *ngTemplateOutlet="promoItems; context: { promoItem: promoItem }"></ng-container>
      </ng-container>

      <div role="status" class="is-vishidden" *ngIf="(updatingPricesLoader$ | async) === PriceLoadingState.LOADED">
        {{ 'destinationSearch.pricesLoaded' | finLocalization }}
      </div>
    </div>
  </div>
</section>

<fcom-modal
  [open]="(calendarOpen$ | async) !== null"
  [fitToContent]="true"
  [buttons]="null"
  [roundedContent]="true"
  [fullHeight]="true"
  [extraWide]="true"
  (close)="closePriceCalendar()"
  data-testid="price-calendar-modal"
>
  <fin-price-calendar
    [openWithParams$]="calendarOpen$"
    [showAddReturn]="true"
    [showSubtitle]="true"
    [ctaLabel]="'bookingSearch.search' | finLocalization"
    (modalClose)="closePriceCalendar()"
    (ctaClicked)="priceCalendarCTAClicked($event)"
  ></fin-price-calendar>
</fcom-modal>
